import React, { useEffect, useState } from "react";
import "./testimonal-slider.css";

const defaultSlides = [
  {
    tab: "Наш подход",
    title: "Нравится наш сайт?",
    content: (
      <>
        <p className="testimonal-slider__lead">
          Мы можем сделать ваш сайт таким же особенным и интересным, но под ваши цели и аудиторию.
        </p>
        <div className="testimonal-slider__block">
          <p className="testimonal-slider__p testimonal-slider__p--sm mb-0">
            Я, Елена Нуруллина, разработала сайт «Форматы» под ключ: от структуры и дизайна до SEO и аналитики.
            Также разработала AI-проект с продуктовой логикой, UX и автоматизацией.
            Делаю сайты, которые не просто красивые, а приводят заявки и усиливают бренд.
          </p>
        </div>
      </>
    ),
  },
  {
    tab: "Доверие",
    title: "Почему мне доверяют",
    textStart: "left",
    content: (
      <ul className="mb-0 p-4 testimonal-slider__list">
        <li>Разработка сайта под ключ: стратегия, структура, дизайн, SEO и аналитика.</li>
        <li>AI и автоматизация: продуктовая логика, UX и техническая реализация решений.</li>
        <li>Воплощаем ваши идеи в работающий продукт, который приносит результат.</li>
      </ul>
    ),
  },
  {
    tab: "Услуги",
    title: "Разрабатываем",
    textStart: "left",
    content: (
      <>
        <p className="testimonal-slider__p testimonal-slider__services-intro">
          <span className="testimonal-slider__service-item">Сайты-визитки и лендинги</span>
          <span className="testimonal-slider__service-item">Корпоративные сайты</span>
          <span className="testimonal-slider__service-item">Сложные веб-сервисы и порталы</span>
        </p>
        <div className="testimonal-slider__result-block">
          <h3 className="testimonal-slider__subtitle">Что вы получите за 14-21 день:</h3>
          <p className="testimonal-slider__p mb-0">
            Продающий сайт + SEO-основа + аналитика + форма заявок + поддержка после запуска.
          </p>
        </div>
      </>
    ),
  },
];

const TestimonalSlider = ({ slides = defaultSlides }) => {
  const [active, setActive] = useState(0);
  const [autorotate, setAutorotate] = useState(true);
  const autorotateTiming = 7000;

  useEffect(() => {
    if (!autorotate) return undefined;
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1 === slides.length ? 0 : prev + 1));
    }, autorotateTiming);
    return () => clearInterval(interval);
  }, [autorotate, slides.length]);

  return (
    <div className="testimonal-slider" data-aos="zoom-in-up" data-aos-duration="900" data-aos-anchor-placement="top-bottom">
      <div className="testimonal-slider__shell">
        <div className="testimonal-slider__title-wrap">
          <div className="testimonal-slider__title" key={slides[active].tab}>
            {slides[active].title}
          </div>
        </div>

        <div className="testimonal-slider__body-holder">
          {slides.map((slide, index) => (
            <div
              key={`body-${slide.tab}`}
              className={`testimonal-slider__body-slide ${active === index ? "is-active" : ""}`}
              aria-hidden={active !== index}
              style={{
                pointerEvents: active === index ? "auto" : "none",
              }}
            >
              <div className={`testimonal-slider__body ${slide.textStart === "left" ? "testimonal-slider__body--left" : ""}`}>
                {slide.content}
              </div>
            </div>
          ))}
        </div>

        <div className="testimonal-slider__tabs">
          {slides.map((slide, index) => (
            <button
              key={slide.tab}
              type="button"
              className={`testimonal-slider__tab ${active === index ? "is-active" : ""}`}
              onClick={() => {
                setActive(index);
                setAutorotate(false);
              }}
            >
              {slide.tab}
            </button>
          ))}
        </div>
      </div>

      {/* <div className="d-flex flex-column flex-md-row gap-2 justify-content-md-end justify-content-xl-start align-items-stretch testimonal-slider__cta">
        <a className="btn btn-primary w-100 w-sm-auto" href="https://t.me/ElenkaSan" target="_blank" rel="noreferrer">
          Написать в Telegram
        </a>
        <a className="btn btn-outline-primary w-100 w-sm-auto" href="mailto:developskillsnow@yandex.ru?subject=Запрос%20на%20аудит%20сайта">
          Заказать аудит
        </a>
      </div> */}
    </div>
  );
};

export default TestimonalSlider;
